import { Box, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

export default function UserInfo() {
  const { currentUser } = useAuth();

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        padding: '8px 16px',
        borderRadius: 1,
        boxShadow: 1,
        zIndex: 1000
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Usuario: {currentUser?.email}
      </Typography>
    </Box>
  );
}